export default __webpack_public_path__ + "static/media/NoMessagesImage.744e1ef3.svg";